import * as angular from "angular";
import {setAngularJSGlobal} from "@angular/upgrade/static";
import "./ng-migration/common/migration";


import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {AppModule} from "./app.module";

setAngularJSGlobal(angular);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
